// extracted by mini-css-extract-plugin
module.exports = {"layout":"BrainableLayout_layout__jHFpN"};